<template>
	<div class="display-flex flex-wrap-wrap gap-50">
		<div v-for="data in props.funds" :key="data.fund.fundriseId">
			<AssetDetailsFundTag :data="data" />
		</div>
	</div>
</template>

<script setup lang="ts">
import AssetDetailsFundTag from '@components/marketing-site/asset-details/asset-details-fund-tag.vue';
import { AssetFundAllocation } from 'types/assets';

interface Props {
	funds: Array<AssetFundAllocation>;
}

const props = defineProps<Props>();
</script>
